import { create } from 'zustand';

import type IAlertModel from '~/types/models/global/AlertModel';

type IUseGlobalStore = {
  alert: IAlertModel;
  isAlertActive: boolean;
  enableAlert: (alert: IAlertModel) => void;
  disableAlert: () => void;
};

const useGlobalStore = create<IUseGlobalStore>(set => ({
  alert: {
    message: '',
    timeout: 0,
    type: 'info',
  },
  isAlertActive: false,

  enableAlert: alertValue =>
    set(() => ({
      alert: alertValue,
      isAlertActive: true,
    })),
  disableAlert: () => set(() => ({ isAlertActive: false })),
}));

export default useGlobalStore;
